document.addEventListener('DOMContentLoaded', function(e) {
  if (!window.location.search) { return; }
  var searchParams = new URLSearchParams(window.location.search);
  var addToCartVariant = searchParams.get('autoAddVariant');
  if (!addToCartVariant) { return; }
  var cartPayload = {
    updates: { [addToCartVariant]: 1 }
  };
  var updateCart = fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(cartPayload)
  }).then(function (response) {
      if (!response.ok) {
        throw new Error(response.status+': '+(response.statusText || 'error'));
      }
      return response.json();
  }).then(function (data) {
      searchParams.delete('autoAddVariant');
      var updatedSearchParams = searchParams.toString();
      var locationWithoutQS = window.location.href.split('?')[0];
      var updatedUrl = !updatedSearchParams ? locationWithoutQS : (locationWithoutQS + '?' + updatedSearchParams);

      window.history.replaceState({}, document.title, updatedUrl);
  }).catch(function (err) {
      console.error(err);
      window.location.href = window.Shopify.routes.root + 'cart/add?id='+addToCartVariant+'&quantity=1';
  });
});